<script>
import ListingModel from "@/views/Boarding/Components/ListingModel.vue";

export default {
    name: "OffBoardings",
    components: {ListingModel}
}
</script>

<template>
    <ListingModel category="OFF"></ListingModel>
</template>